module.exports = __webpack_public_path__ + "static/img/customerServiceQR.f47bc3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/customerServiceQR.png
// module id = BI6n
// module chunks = 22